import React, { useRef, useEffect, useContext, useState } from "react";
import Slider from "react-slick";
import Select from "react-select";
import { useCookies } from "react-cookie";
import Link from "next/link";
import { useRouter } from "next/router";
import Head from "next/head";
import { AppContext } from "../../../context/state";
import Accordion from "../../../components/accordion/Accordion";
import MatchupsItem from "../../../components/MatchupsItem/MatchupsItem";
import Checkbox from "../../../components/form/Checkbox";
import { authGetRequest } from "../../../utils/authGetRequest";
import MainLayout from "../../../components/MainLayout/MainLayout";
import { Form, Row, InputGroup, Button, Col } from "react-bootstrap";
import Utils from "../../../utils/Utils";
import SQBestBetsSreenshot from "../../../assets/images/SQBestBetsSreenshot.png";
import { appServerSideProps } from "../../../utils/getAppService";
import WinningMetrics from "../../../components/WinningMetrics";
import { getDefYear } from "../../../constants/main";
import { SIGNUPS_CLOSED_MESSAGE } from "../../../constants/main";
const accordionData = [
  {
    "@type": "Question",
    name: "How are ShotQuality’s NCAAB bets determined?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "ShotQuality uses Vegas odds to calculate and identify the high-probability games with the most points of value. Vegas sets lines according to actual results, the ShotQuality Betting Model makes projections based on expected scores, which eliminates variability and increases predictive accuracy.",
    },
    id: "accordionData1",
  },
  {
    "@type": "Question",
    name: "Does ShotQuality Bets offer free NCAAB picks?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Yes, ShotQuality Bets offers free college basketball picks on Twitter throughout the season. Play recommendations will also be discussed on the ShotQuality Bets Podcast on Mondays and Thursdays. Make sure to sign up to receive alerts for everything ShotQuality and exclusive free trial offers!",
    },
    id: "accordionData2",
  },
  {
    "@type": "Question",
    name: "What makes ShotQuality the best NCAA Basketball predictions?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Vegas odds for men's basketball can be misleading. They are determined by a herd mentality, but often don’t factor nuanced data into calculations on a large scale. The ShotQuality Bets model analyzes nearly every aspect of in-game play to more deeply understand each team’s competitive advantage and how it would stack up again a respective opponent.",
    },
    id: "accordionData3",
  },
  {
    "@type": "Question",
    name: "Does ShotQuality provide NCAA expert picks?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "ShotQuality is the expert. With a 53.5% win percentage, our algorithm is one of the most, if not the most, expert NCAA handicappers in the industry. We follow math, not feelings. We encourage NCAA basketball experts to compare their analysis with the our algorithm’s findings.",
    },
    id: "accordionData4",
  },
  {
    "@type": "Question",
    name: "What are the best NCAA Basketball picks today?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "NCAA basketball lines change every day; as teams, schedules and match-ups are constantly evolving. It’s impossible for one person to keep track of every line, let alone uncover the best opportunities among them. The ShotQuality Bets Value Finder makes is seamless to track all NCAAB lines and find the best opportunities.",
    },
    id: "accordionData5",
  },
  {
    "@type": "Question",
    name: "Are ShotQuality Bets lines generated by a computer?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Yes, ShotQuality Bets' computer algorithms recommend the best lines using a points-of-value system. No emotion, no human error, just algorithmically proven projections to help you make smarter plays.",
    },
    id: "accordionData6",
  },
];
const accordionDataWnba = [
  {
    "@type": "Question",
    name: "How are ShotQuality’s WNBA bets determined?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "ShotQuality uses Vegas odds to calculate and identify the high-probability games with the most points of value. Vegas sets lines according to actual results, the ShotQuality Betting Model makes projections based on expected scores, which eliminates variability and increases predictive accuracy.",
    },
    id: "accordionData1",
  },
  {
    "@type": "Question",
    name: "Does ShotQuality Bets offer free WNBA picks?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Yes, ShotQuality Bets offers free WNBA basketball picks on Twitter throughout the season. Play recommendations will also be discussed on the ShotQuality Bets Podcast on Mondays and Thursdays. Make sure to sign up to receive alerts for everything ShotQuality and exclusive free trial offers!",
    },
    id: "accordionData2",
  },
  {
    "@type": "Question",
    name: "What makes ShotQuality the best WNBA Basketball predictions?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Vegas odds for WNBA basketball can be misleading. They are determined by a herd mentality, but often don’t factor nuanced data into calculations on a large scale. The ShotQuality Bets model analyzes nearly every aspect of in-game play to more deeply understand each team’s competitive advantage and how it would stack up again a respective opponent.",
    },
    id: "accordionData3",
  },
  {
    "@type": "Question",
    name: "Does ShotQuality provide WNBA expert picks?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "ShotQuality is the expert. With a 53.5% win percentage, our algorithm is one of the most, if not the most, expert WNBA handicappers in the industry. We follow math, not feelings. We encourage WNBA basketball experts to compare their analysis with the our algorithm’s findings.",
    },
    id: "accordionData4",
  },
  {
    "@type": "Question",
    name: "What are the best WNBA Basketball picks today?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "WNBA basketball lines change every day; as teams, schedules and match-ups are constantly evolving. It’s impossible for one person to keep track of every line, let alone uncover the best opportunities among them. The ShotQuality Bets Value Finder makes is seamless to track all WNBA lines and find the best opportunities.",
    },
    id: "accordionData5",
  },
  {
    "@type": "Question",
    name: "Are ShotQuality Bets lines generated by a computer?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Yes, ShotQuality Bets' computer algorithms recommend the best lines using a points-of-value system. No emotion, no human error, just algorithmically proven projections to help you make smarter plays.",
    },
    id: "accordionData6",
  },
];
let blogSetting = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 6,
  slidesToScroll: 3,
  initialSlide: 1,
  autoPlay: true,
  className: "slick-list-custom",
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 2,
        dots: false,
        infinite: true,
        autoPlay: true,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
        dots: false,
        infinite: true,
        autoPlay: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        slidesToShow: 1.7,
        slidesToScroll: 1,
        initialSlide: 0,
        dots: false,
        centerMode: false,
        infinite: true,
        autoPlay: true,
      },
    },
    {
      breakpoint: 375,
      settings: {
        arrows: true,
        slidesToShow: 1.7,
        slidesToScroll: 1,
        initialSlide: 0,
        dots: false,
        centerMode: false,
        infinite: true,
        autoPlay: true,
      },
    },
  ],
};

const MatchupTool = ({ user }) => {
  const router = useRouter();
  let leagueFromUrl = router.query?.league;
  let league = leagueFromUrl === "ncaa" ? "college_mens" : leagueFromUrl;
  league = leagueFromUrl === "ncaaw" ? "college_womens" : league;
  const year = getDefYear(league);

  const [authToken, setAuthToken] = useState(null);
  useEffect(() => {
    setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());
  }, []);
  const [cookies, setCookie] = useCookies(["token_access, name"]);
  const { store } = useContext(AppContext);
  const [matchupToday, setMatchupToday] = useState(null);
  const [teams, setTeams] = useState(null);
  const [team, setTeam] = useState("");
  const [opponent, setOpponent] = useState("");
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const sliderRef = useRef(null);
  const checkBoxRef = useRef(null);

  const isStandardPlan = Utils.hasStandardPlan(user) || Utils.hasTrial(user);
  const isPremiumPlan = Utils.hasPremiumPlan(user);
  const isPaidPlan = (isStandardPlan || isPremiumPlan) && user?.has_paid;
  const isTrader = Utils.isTrader(user);
  useEffect(() => {
    fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${league}/${year}/team-standings`)
      .then((response) => response.json())
      .then((response) => {
        let teams = [];
        response.data.forEach((val) => {
          teams.push({ value: val.Team_Name, label: val.Team_Name });
        });
        teams.sort((a, b) => {
          let fa = a.value === null ? null : a.value.toLowerCase();
          let fb = b.value === null ? null : b.value.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
        setTeams(teams);
      })
      .catch(async (err) => {
        if (err.message.includes("401")) {
          try {
            const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
              body: authToken,
            })
              .then((res) => res.json())
              .then((response) => {
                if (response.access_token) {
                  setAuthToken(null);
                  setCookie("token_access", response.access_token);
                  setAuthToken(response.access_token);
                }
              });
          } catch (error) {
            console.log(error);
          }
        }
        console.log(err);
      });
  }, [authToken]);

  useEffect(() => {
    if (authToken) {
      authGetRequest(`/api/${league}/matchup/today`, authToken)
        .then((response) => response.data)
        .then((response) => {
          if (response.data.length < 6) {
            blogSetting.slidesToShow = response.data.length;
          }
          setMatchupToday(response.data);
        })
        .catch(async (err) => {
          if (err.message.includes("401")) {
            try {
              const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                body: authToken,
              })
                .then((res) => res.json())
                .then((response) => {
                  if (response.access_token) {
                    setCookie("token_access", response.access_token);
                    setAuthToken(response.access_token);
                  }
                });
            } catch (error) {
              console.log(error);
            }
          }
          console.log(err);
        });
    }
  }, [authToken]);

  const handleCheckboxClick = () => {
    return checkBoxRef.current.checked ? setIsCheckboxChecked(true) : setIsCheckboxChecked(false);
  };

  const handleScroll = (event) => {
    if (sliderRef.current) {
      if (event.deltaY < 0) {
        sliderRef.current.slickPrev();
      } else {
        sliderRef.current.slickNext();
      }
      event.preventDefault();
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredMatchups = matchupToday?.filter((matchup) => {
    return (
      matchup.home.toLowerCase().includes(searchTerm.toLowerCase()) ||
      matchup.away.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  useEffect(() => {
    const box = document.getElementById("matchup-slider");
    if (box) {
      box.addEventListener("wheel", handleScroll);
    }

    return () => {
      if (box) {
        box.removeEventListener("wheel", handleScroll);
      }
    };
  }, [matchupToday]);

  const downloadProjections = () => {
    const dataWithoutGameIDandDate = matchupToday.map((matchup) => {
      const { game_id, date, time, ...rest } = matchup;
      return rest;
    });
    Utils.jsonToCsvWithFilename(
      dataWithoutGameIDandDate,
      `${leagueFromUrl}_projections_${new Date().toISOString()}.csv`
    );
  };
  return (
    <>
      <Head>
        <meta
          property="description"
          content="Get the edge in your college basketball betting with our advanced predictive matchup breakdowns. Our expert team
analyzes key statistics, player matchups, and team trends to provide in-depth insights and predictions for every game. Don't miss out on valuable
information and increase your chances of winning with our college basketball matchup breakdowns."
        />
      </Head>
      <MainLayout>
        <main id="MatchupTool" style={{ minHeight: "100vh" }}>
          {!isPaidPlan ? (
            <div className="col-md-12 dummyLockWrapper" style={{ height: "100vh", background: "#e4e5e9" }}>
              <div className="imgWrapper">
                <img src={SQBestBetsSreenshot.src} className="bracketBackground" alt="" />
              </div>

              <Col
                className="dummyLock"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  position: "absolute",
                  top: "20px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <h3>Want to see more?</h3>
                <p>{SIGNUPS_CLOSED_MESSAGE}</p>
                <div className="requestEmailWrapper">
                  <Row className="mm-email-wrapper">
                    <Form className="mm-form">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <InputGroup className="mb-3 mm-input-main-wrapper">
                          {user ? null : (
                            <Button
                              className={`mm-access-button mx-auto`}
                              style={{
                                backgroundColor: "#f26b0b",
                                color: "white",
                                padding: "10px 30px",
                                border: "none",
                              }}
                              onClick={() => router.push("/login")}
                            >
                              Sign In
                            </Button>
                          )}
                        </InputGroup>
                      </Form.Group>
                    </Form>
                  </Row>
                </div>
              </Col>
            </div>
          ) : (
            <div className="MatchupTool">
              <section className="header-primary">
                <div className="container-fluid">
                  <div className="row align-items-center">
                    <div className="box col-md-12 titles-container">
                      {/* <h2>Today’s Matchups</h2>
                    <p>Scroll through the days games and pick one team</p> */}
                    </div>
                  </div>
                </div>
              </section>
              {/* hiding this part using 1===2 */}
              {1 === 2 && matchupToday && matchupToday.length > 0 && (
                <>
                  <section className={`slider col-md-12`}>
                    <div className="d-flex justify-content-center align-items-center flex-column">
                      <input
                        style={{ maxWidth: "20rem" }}
                        type="text"
                        placeholder="Search Todays matchups..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="search-input form-control w-auto mb-4"
                      />
                      {filteredMatchups.length === 0 && searchTerm.length > 0 && (
                        <p className="text-center">
                          No results found <br />
                          <span
                            className="btn btn-primary mt-2"
                            onClick={() => {
                              setSearchTerm("");
                            }}
                          >
                            X Clear
                          </span>
                        </p>
                      )}
                    </div>
                    <div className="row">
                      <div
                        id="matchup-slider"
                        className={`col-12 d-none d-sm-none d-md-block matchup-slider ${
                          searchTerm && "hide-duplicates"
                        }`}
                      >
                        <Slider {...blogSetting} ref={sliderRef}>
                          {filteredMatchups.map((blog, index) => (
                            <Link
                              href={`/${leagueFromUrl}/matchup-output/${blog.home}/${blog.away}/false`}
                              target={"_blank"}
                              key={`${index + 999}`}
                            >
                              <MatchupsItem isTrader={isTrader} {...blog} />
                            </Link>
                          ))}
                        </Slider>
                      </div>
                      <div className="col-12 d-block d-md-none box-shadow-inner">
                        <div
                          className="overflow-auto text-center matchup-slider-mobile mt-2 mb-2"
                          style={{ maxHeight: "55vh" }}
                        >
                          {filteredMatchups.map((blog, index) => (
                            <Link
                              href={`/${leagueFromUrl}/matchup-output/${blog.home}/${blog.away}/false`}
                              target={"_blank"}
                              key={`${index + 999}`}
                            >
                              <MatchupsItem isTrader={isTrader} {...blog} />
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  </section>
                  {!isTrader && isPremiumPlan && (
                    <div className="text-center mb-5">
                      <button className="btn btn-secondary" onClick={() => downloadProjections()}>
                        {" "}
                        Export to CSV{" "}
                      </button>
                    </div>
                  )}
                </>
              )}
              {teams ? (
                <section className="select-teams-container">
                  <div className="box col-md-12 titles-container align-items-center justify-content-center">
                    <h2>Custom Matchups</h2>
                    <p>Select or type team name here to create custom matchups</p>
                  </div>

                  <div className="select-container col-md-12">
                    <div className="col-md-4">
                      <p>Home Team</p>
                      <Select
                        options={teams}
                        onChange={(e) => {
                          setTeam(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <p>Opponent (Away)</p>
                      <Select
                        options={teams}
                        onChange={(e) => {
                          setOpponent(e.value);
                        }}
                      />
                    </div>
                  </div>

                  <Checkbox
                    id="miscAnalysisConferenceOnlyCheck"
                    ref={checkBoxRef}
                    onClick={handleCheckboxClick}
                    label={["Check if the game is in a ", <b key="neutral-location">neutral location</b>]}
                    checked={isCheckboxChecked}
                  />

                  {team && opponent ? (
                    <Link
                      href={`/${
                        leagueFromUrl === "college_womens"
                          ? "ncaaw"
                          : leagueFromUrl === "college_mens"
                          ? "ncaa"
                          : leagueFromUrl
                      }/matchup-output/${team}/${opponent}/${isCheckboxChecked ? "true" : "false"}`}
                      target="_blank"
                      onClick={(event) => {
                        if (!team || !opponent) {
                          event.preventDefault();
                        }
                      }}
                    >
                      <button className="select-teams-button">Show Matchups Stats</button>
                    </Link>
                  ) : (
                    // disable button
                    <button disabled={true} className="select-teams-button" style={{ cursor: "no-drop" }}>
                      Show Matchups Stats
                    </button>
                  )}
                </section>
              ) : (
                <h3 className="text-center pt-5 pb-5">
                  We're working on {leagueFromUrl.toUpperCase()} Custom Matchups. Data will be available soon!
                </h3>
              )}

              <section className="accordion-container">
                <div className="row">
                  <div className="col-md-5">
                    <div className="box col-md-12 titles-container align-items-center justify-content-center">
                      <h2>FAQs</h2>
                      <p>Here you can find frequently asked questions</p>
                    </div>
                  </div>
                  <div className="col-md-7" itemScope itemType="https://schema.org/FAQPage">
                    {store.leagueType === "wnba"
                      ? accordionDataWnba.map(({ name, acceptedAnswer, id }) => {
                          return <Accordion title={name} content={acceptedAnswer.text} id={id} key={name} />;
                        })
                      : accordionData.map(({ name, acceptedAnswer, id }) => {
                          return <Accordion title={name} content={acceptedAnswer.text} id={id} key={name} />;
                        })}
                  </div>
                </div>
              </section>
              <WinningMetrics targetPage={"ModelSandbox"} />
            </div>
          )}
        </main>
      </MainLayout>
    </>
  );
};

export default MatchupTool;

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  return { props: { user } };
});
